<template>
	<div class="l-edit-dialog-box">
		<el-form :model="form_data" label-width="160px" ref="form" :rules="rules" label-position="left" v-loading="loading">
			<el-form-item label="角色名称" prop="name">
				<el-input v-model="form_data.name" autocomplete="off" placeholder="请输入角色名称"></el-input>
			</el-form-item>
			<!-- <el-form-item label="角色别名" prop="company_name">
				<el-input v-model="form_data.company_name" autocomplete="off" placeholder="请输入角色别名"></el-input>
			</el-form-item> -->
			<el-form-item label="排序" prop="sort_num">
				<el-input v-model="form_data.sort_num" autocomplete="off" placeholder="请输入排序"></el-input>
			</el-form-item>
				<el-form-item label="类型" prop="of_type">
				<el-radio-group v-model="form_data.of_type">
					<el-radio :label="1">后台管理</el-radio>
					<el-radio :label="2">小程序</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="状态" prop="state">
				<el-radio-group v-model="form_data.state">
					<el-radio :label="1">启用</el-radio>
					<el-radio :label="0">禁用</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="角色类型" prop="type">
				<el-select v-model="form_data.type" placeholder="请选择角色类型">
					<el-option label="系统角色（不对外开放）" :value="1"></el-option>
					<el-option label="普通角色" :value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="是否后台最高权限角色" prop="grade">
				<el-radio-group v-model="form_data.grade"  :disabled="form_data.type != 1">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="2">否</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<div class="l-dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: "l-role-edit",
	props: {
		id: {
			type: [Number, String],
			default: null,
		},
		visible: {
			type: Boolean,
		},
	},
	computed: {
		hasId() {
			return this.$props.id !== null;
		},
	},
	data() {
		return {
			loading: false, //页面是否加载中

			//表单数据
			form_data: {
				name: "",
				company_name: "",
				sort_num: 1000,
				state: 1,
				temp_role_type: 0,
				can_change_permission: 0,
				type: 2,
				grade: 2 ,
				of_type:1
			},
			//表单验证规则
			rules: {
				name: [{ required: true, message: "角色名称不能为空", trigger: "change" }],
				// company_name: [{ required: true, message: "别名不能为空", trigger: "change" }],
				sort_num: [{ type: "number", required: true, message: "排序不能为空", trigger: "change" }],
				state: [{ type: "number", required: true, message: "请选择状态", trigger: "change" }],
				temp_role_type: [{ type: "number", required: true, message: "请选择角色类型", trigger: "change" }],
				can_change_permission: [{ type: "number", required: true, message: "请选择是否允许更改权限", trigger: "change" }],
				type: [{ type: "number", required: true, message: "请选择角色类型", trigger: "change" }],
			},
			//提交按钮是否显示加载中
			submitting: false,
		};
	},
	watch: {
		visible: {
			immediate: true,
			handler(val) {
				if (val) {
					this.getData();
				}
			},
		},
	},

	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("update:visible", false);
		},
		//获取数据
		getData() {
			if (this.hasId) {
				this.loading = true;
				this.$_invoke("role_getEditData", { id: this.$props.id })
					.then((ret) => {
						this.form_data = ret.data;
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},

		//提交数据
		handleSubmit() {
			if (this.loading) return;
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.submitting = true;
					if (!this.hasId) {
						//添加
						this.$_invoke("role_save", this.form_data)
							.then(() => {
								this.$_msg.success("添加成功");
								this.$emit("on-success");
							})
							.finally(() => {
								this.submitting = false;
							});
					} else {
						//修改
						this.$_invoke("role_update", this.form_data)
							.then(() => {
								this.$_msg.success("修改成功");
								this.$emit("on-success");
							})
							.finally(() => {
								this.submitting = false;
							});
					}
				}
			});
		},

		//重置数据
		handleReset() {
			this.$refs.form.resetFields();
		},
	},
};
</script>
